module.exports = __webpack_public_path__ + "img/mv--hakari_sprite3.463d19ac.png";